<template>
  <div>
    <v-checkbox
      v-for="(option, k) in question.options"
      :key="`select-${k}`"
      v-model="value"
      :label="option.text"
      :value="`${option.id}~${option.value}`"
      :multiple="true"
    ></v-checkbox>
  </div>
</template>

<script>
  export default {
    name: 'survey-multiple-answer',
    props: {
      question: {
        type: Object,
        default: () => {}
      },
    },
    data() {
      return {
        value: []
      }
    },
    watch: {
      value(newValue, oldValue) {
        if (newValue.length !== oldValue.length) {
          this.$emit('setValue', { newValue, questionId: this.question.id})
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/surveys/run/answer-multiple.vue